import {
  ActivityChangeExtensionOptions,
  createActivityChangeExtension,
  createActivityChangeExtensions,
  useActivityChangeExtensions,
} from '@spotify/plugin-confidence-activity-react';

export const IssueUpdatesChangeExtensions = createActivityChangeExtensions(
  'issue-updates-change',
);

export const useIssueUpdatesChangeExtensions = () => {
  return useActivityChangeExtensions(IssueUpdatesChangeExtensions);
};

export const createIssueUpdatesChangeExtension = (
  options: ActivityChangeExtensionOptions,
) => {
  return createActivityChangeExtension(options);
};
